import React from 'react';
import classnames from 'classnames';
import Box from '@material-ui/core/Box';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import { useTooltipStyles } from '../../utils/styles.esm.js';

const BarChartTooltip = (props) => {
  const { title, content, subtitle, topRight, actions, children } = props;
  const classes = useTooltipStyles();
  const titleClassName = classnames(classes.truncate, {
    [classes.maxWidth]: topRight === void 0
  });
  return /* @__PURE__ */ React.createElement(Box, { className: classes.tooltip, display: "flex", flexDirection: "column" }, /* @__PURE__ */ React.createElement(
    Box,
    {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "baseline",
      px: 2,
      pt: 2
    },
    /* @__PURE__ */ React.createElement(Box, { display: "flex", flexDirection: "column" }, /* @__PURE__ */ React.createElement(Typography, { className: titleClassName, variant: "h6" }, title), subtitle && /* @__PURE__ */ React.createElement(Typography, { className: classes.subtitle, variant: "subtitle1" }, subtitle)),
    topRight && /* @__PURE__ */ React.createElement(Box, { ml: 2 }, topRight)
  ), content && /* @__PURE__ */ React.createElement(Box, { px: 2, pt: 2, className: classes.maxWidth }, /* @__PURE__ */ React.createElement(Typography, { variant: "body1", paragraph: true }, content)), /* @__PURE__ */ React.createElement(Box, { display: "flex", flexDirection: "column", p: 2 }, children), actions && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Divider, { className: classes.divider, variant: "fullWidth" }), /* @__PURE__ */ React.createElement(Box, { display: "flex", flexDirection: "column", p: 2 }, actions)));
};

export { BarChartTooltip };
//# sourceMappingURL=BarChartTooltip.esm.js.map
